import { getLeadAttributes, type GetLeadAttributesType } from '@repo/advanced-filters';
import { useGetGraphqlDataQuery, type UseQueryResult } from '@repo/services';
import { Select, type SelectProps } from 'antd';

export default function LeadAttributesDropdown({
  ...props
}: SelectProps) {
  const {
    data,
    isLoading,
  } = useGetGraphqlDataQuery<UseQueryResult<GetLeadAttributesType>>({
    document: getLeadAttributes,
  });

  const options = data?.leadAttributes.map((attribute) => ({
    label: attribute.label,
    value: attribute.schemaName,
  })) || [];

  return (
    <Select
      options={options}
      loading={isLoading}
      showSearch
      style={{ minWidth: '14rem' }}
      optionFilterProp="label"
      placeholder="Select Lead Attribute"
      {...props}
    />
  );
}
